export default __webpack_public_path__ + "static/media/departmenticon.58918087.svg";